import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
    overflowX: 'auto',
    borderRadius: '8px',
    borderTop: '1px solid',
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderTopColor: theme.palette.grey.main,
    borderLeftColor: theme.palette.grey.main,
    borderRightColor: theme.palette.grey.main,
  },
}));

// eslint-disable-next-line no-unused-vars
const TableHeaderRow = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.blue.dark,
  },
}))(TableRow);

// eslint-disable-next-line no-unused-vars
const TableHeaderCell = withStyles((theme) => ({
  head: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    fontSize: 15,
  },
}))(TableCell);

// eslint-disable-next-line no-unused-vars
export const TableRowData = withStyles((theme) => ({
  hover: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
  },
  selected: {
    backgroundColor: `${theme.palette.action.selected} !important`,
  },
}))(TableRow);

const SimpleGrid = ({ columnNames, renderRows }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Table>
        <TableHead>
          {columnNames && columnNames.length > 0 && (
            <TableHeaderRow>
              {columnNames.map((x) => (
                <TableHeaderCell key={x}>{x}</TableHeaderCell>
              ))}
            </TableHeaderRow>
          )}
        </TableHead>
        <TableBody className={classes.tableBody}>{renderRows()}</TableBody>
      </Table>
    </Paper>
  );
};

SimpleGrid.propTypes = {
  columnNames: PropTypes.arrayOf(PropTypes.string),
  renderRows: PropTypes.func.isRequired,
};

SimpleGrid.defaultProps = {
  columnNames: null,
};

export default SimpleGrid;
